// One button, four intents. Primary = the one thing to do on a screen; ghost = secondary;
// danger = destructive (always confirmed elsewhere); link = quiet inline action.
import React from 'react';
import { Pressable, ActivityIndicator, StyleSheet, ViewStyle } from 'react-native';
import { Text } from './Text';
import { radius, makeStyles, useTheme } from '../theme';

export type BtnKind = 'primary' | 'ghost' | 'danger' | 'link';

export function Btn({ label, onPress, busy, disabled, kind = 'primary', style, small }: {
  label: string; onPress: () => void; busy?: boolean; disabled?: boolean; kind?: BtnKind; style?: ViewStyle; small?: boolean;
}) {
  const theme = useTheme(); const s = useStyles();
  const off = !!disabled || !!busy;
  return (
    <Pressable
      onPress={onPress} disabled={off} accessibilityRole="button" accessibilityLabel={label}
      style={({ pressed }) => [s.base, small && s.small, s[kind], off && { opacity: 0.5 }, pressed && !off && { opacity: 0.7 }, style]}
    >
      {busy ? <ActivityIndicator color={kind === 'primary' ? theme.accentInk : theme.ink} size="small" />
        : <Text style={[s.text, small && { fontSize: 13 }, kind === 'ghost' && { color: theme.ink }, kind === 'danger' && { color: theme.deny }, kind === 'link' && { color: theme.accent }]}>{label}</Text>}
    </Pressable>
  );
}

const useStyles = makeStyles((theme) => StyleSheet.create({
  base: { minHeight: 44, paddingHorizontal: 16, paddingVertical: 11, borderRadius: radius.md, alignItems: 'center', justifyContent: 'center', minWidth: 84 },
  small: { minHeight: 36, paddingHorizontal: 12, paddingVertical: 8, minWidth: 64 },
  primary: { backgroundColor: theme.accent },
  ghost: { backgroundColor: theme.surface2, borderWidth: 1, borderColor: theme.border },
  danger: { backgroundColor: 'transparent', borderWidth: 1, borderColor: theme.denyBorder },
  link: { backgroundColor: 'transparent', paddingHorizontal: 6, minWidth: 0 },
  text: { color: theme.accentInk, fontWeight: '800', fontSize: 14.5 },
}));
